import React, { Ref, forwardRef, useCallback, SyntheticEvent } from 'react';
import _get from 'lodash/get';
import { GenericInput, GenericInputProps } from './GenericInput';
import { useFormikContext } from 'formik';
import moment from 'moment-timezone';

interface Props extends GenericInputProps {
  name: string;
}

export const DateInput = forwardRef((props: Props, ref: Ref<any>) => {
  const formik = useFormikContext<any>();
  const { name } = props;

  const onChange = useCallback(
    (e: SyntheticEvent<HTMLInputElement>) => {
      const val = e.currentTarget.value;
      if (!val) {
        formik.setFieldValue(name, '');
      } else {
        formik.setFieldValue(name, moment(val).format('YYYY-MM-DD'));
      }
    },
    [formik, name],
  );

  const formikValue = _get(formik.values, name);
  const value = formikValue ? moment(formikValue).format('YYYY-MM-DD') : '';

  return (
    <GenericInput
      {...props}
      component="input"
      type="date"
      ref={ref}
      onChange={onChange}
      value={value}
    />
  );
});
